exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pdf-export-mode[data-v-54d0ae41] {\n    background-color: #dddddd;\n    text-align: left;\n}\n.pdf-export-row td[data-v-54d0ae41] {\n    border-bottom: 1px solid #9e9e9e !important; /* ciemniejsza linia */\n}\ntable[data-v-54d0ae41] {\n    border-collapse: collapse !important;\n}\n.group-name-pdf[data-v-54d0ae41]{\n    background-color: #e0e0e0;\n    color: black;\n}\n.th-export-pdf[data-v-54d0ae41] {\n    background-color: #bbbbbb;\n    color: black;\n    padding: 6px;\n    border: 1px solid white !important;\n}\n", ""]);

// exports
